"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Container_1 = require("./Container");
const Context_1 = require("./Context");
;
const withModal = (WrappedComponent, config) => {
    const currentRef = (0, react_1.createRef)();
    const show = () => {
        var _a;
        (_a = currentRef.current) === null || _a === void 0 ? void 0 : _a.show();
    };
    const showPopup = (event) => {
        var _a;
        (_a = currentRef.current) === null || _a === void 0 ? void 0 : _a.showPopup(event);
    };
    const hide = () => {
        var _a;
        (_a = currentRef.current) === null || _a === void 0 ? void 0 : _a.hide();
    };
    const setState = (data) => {
        if (typeof currentRef.current.setState !== 'function')
            return;
        currentRef.current.setState(data);
    };
    return Object.assign(Object.assign({}, (0, react_1.forwardRef)((props, ref) => {
        var _a, _b, _c;
        const modalRef = (0, react_1.useRef)(null);
        const [stateData, setStateData] = (0, react_1.useState)();
        const id = (0, react_1.useId)();
        const [currentConfig, _setConfig] = (0, react_1.useState)(config);
        const setConfig = (config) => {
            _setConfig((currentConfig) => (Object.assign(Object.assign({}, currentConfig), config)));
        };
        (0, react_1.useEffect)(() => {
            _setConfig(config);
        }, [config]);
        (0, react_1.useImperativeHandle)(currentRef, () => (Object.assign(Object.assign({}, modalRef.current), { setState: setStateData })));
        return ((0, jsx_runtime_1.jsx)(Context_1.WhithModalContext.Provider, { value: {
                setConfig,
                state: stateData,
                footerRef: (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.footerRef,
                showPopup,
                show,
                hide
            }, children: (0, jsx_runtime_1.jsx)(Container_1.Container, Object.assign({ name: (_b = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.name) !== null && _b !== void 0 ? _b : id, title: (_c = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.title) !== null && _c !== void 0 ? _c : '' }, currentConfig, { ref: modalRef, children: (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props, { ref: ref })) })) }));
    })), { showPopup,
        show,
        hide,
        setState });
};
exports.withModal = withModal;
